import { features, mediaMentions } from './aboutData';
import { useState } from 'react';
import '../styles/about.css';
import '../styles/sectionShared.css';

function AboutSection() {
  const [storyExpanded, setStoryExpanded] = useState(false);

  return (
    <section className="about-section" id="bakgrund" aria-labelledby="about-heading">
      <div className="section-header">
        <p className="section-overline">Vem är jag?</p>
        <h2 id="about-heading">Bakgrund och resa</h2>
      </div>

      <div className="about-grid">
      <article className="about-card about-story-card">
          <p className="about-story-lead">
            Jag har en kandidatexamen som dataingenjör och har även utbildat mig inom bland annat
            hållbar affärsutveckling. Det har gett mig en bra kombination av teknisk förståelse och ett
            bredare perspektiv på hur man bygger lösningar som både är användbara och långsiktiga.
          </p>

          <div
            className={`about-story-more ${storyExpanded ? 'is-open' : ''}`}
            id="about-story-more"
          >
            <p>
              Tidigare ledde jag Ophelia AI som projektledare och drev arbetet från idé och vision
              till en färdig produkt i produktion. Vi arbetade agilt, och jag ansvarade för
              planering, prioritering, samordning och att hålla ihop arbetet mellan teknik, forskning
              och verksamhet.
            </p>
            <p>
              Projektet började som examensarbetet <em>Using AI to Prevent Domestic Violence</em>,
              men utvecklades snabbt till ett verkligt produktinitiativ. Jag arbetade också med
              datainsamling, kvalitetssäkring av underlag och dialog med socialtjänst,
              brottsofferjour och andra samhällsaktörer för att se till att lösningen byggdes utifrån
              verkliga behov.
            </p>
            <p>
              Ophelia AI drivs idag vidare inom inkubatorn på{' '}
              <a
                className="about-inline-link"
                href="https://sciencepark.se/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Science Park Jönköping
              </a>
              , även om jag själv inte längre är en del av projektet.
            </p>
            <a className="about-link" href="https://www.opheliaai.se/" target="_blank" rel="noreferrer">
              Besök Ophelia AI
            </a>
          </div>

          <button
            className="about-read-more"
            type="button"
            aria-expanded={storyExpanded}
            aria-controls="about-story-more"
            onClick={() => setStoryExpanded((v) => !v)}
          >
            {storyExpanded ? 'Visa mindre' : 'Läs mer'}
          </button>
        </article>

        <aside className="about-card about-list-card">
          <h3>Kompetensprofil</h3>
          <ul>
            {features.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </aside>
      </div>

      <nav className="about-cta" aria-label="Fortsätt läsa">
        <a className="about-cta-link" href="#projekt">
          Se utvalda uppdrag
        </a>
        <span className="about-cta-sep" aria-hidden="true">
          ·
        </span>
        <a className="about-cta-link about-cta-link--quiet" href="#kontakt">
          Kontakta mig
        </a>
      </nav>

      <div className="media-grid">
        {mediaMentions.map((item) => (
          <article className="media-card" key={item.title}>
            <img src={item.image} alt={item.title} />
            <div className="media-content">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
              <a href={item.url} target="_blank" rel="noreferrer">
                {item.linkLabel}
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default AboutSection;
